import { render } from "./index.vue?vue&type=template&id=1cbeeb95"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__